import style from "./blog.module.css";
import Proyecto1 from "./P1";
import Proyecto2 from "./P2";
import Proyecto3 from "./P3";


const Proyectos: React.FC = () => {
  //https://www.instagram.com/p/C25b0ygATVB/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==
  return (
    <main className={style.MasterBoxBlog}>
      <Proyecto1 /> 
      <Proyecto2 />
      <Proyecto3 />     
    </main>
  );
};

export default Proyectos;
